import React from "react";

import { ActivitiesManagementWorkflowType } from "../ActivitiesManagementActions";
import Dialog from "../../../../components/Dialog";
import ActivitiesManagementDetails from "./ActivitiesManagementDetails";
import DialogStyles from "../../../../styles/components/DialogStyles";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import { ActivitiesManagementProvider } from "../../../../context/ActivitiesManagementContext";
import ActivitiesManagementModalHeader from "./ActivitiesManagementModalHeader";

const { StyledContainerButton } = DialogStyles;
const { DefaultButtonLink } = ButtonStyles;
interface IModalProps {
    open: boolean;
    workflow: ActivitiesManagementWorkflowType | null;
    onClose: (callback?: any) => void;
}

const ActivitiesManagementModal: React.FC<IModalProps> = ({
    open,
    workflow,
    onClose,
}) => {
    const handleOnClose = () => {
        onClose();
    };

    return (
        <Dialog
            openModal={open}
            onHide={handleOnClose}
            size="lg"
            style={{
                width: "100%",
            }}
            dialogClassName="modal-90w"
        >
            <ActivitiesManagementProvider>
                <ActivitiesManagementModalHeader workflow={workflow} />
                <ActivitiesManagementDetails onClose={() => onClose} />
                <StyledContainerButton>
                    <DefaultButtonLink onClick={() => onClose()}>
                        Cancelar
                    </DefaultButtonLink>
                </StyledContainerButton>
            </ActivitiesManagementProvider>
        </Dialog>
    );
};

export default ActivitiesManagementModal;
